import { useCbhFlag } from "@src/appV2/FeatureFlags";
import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";

export function useIsSeePastShiftsEnabled() {
  return useCbhFlag(CbhFeatureFlag.SEE_PAST_SHIFTS_AND_PAPER_TIMESHEET, { defaultValue: false });
}
